var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4824 67.9645C45.3517 67.9645 44.3466 67.4619 43.7185 66.7083L24.7486 46.1052C23.3667 44.5978 23.4925 42.2107 24.9999 40.8288C26.5073 39.4469 28.8944 39.5726 30.2763 41.0801L46.6079 58.7936L91.8342 13.6931C93.3416 12.1856 95.7287 12.1856 97.1106 13.6931C98.618 15.2005 98.618 17.5876 97.1106 18.9695L49.1207 66.8339C48.4924 67.5877 47.4875 67.9645 46.4824 67.9645Z",
    fill: "#91B848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 100C22.4874 100 0 77.5126 0 50.0001C0 22.4876 22.4874 0 50.0001 0C52.1359 0 53.7689 1.63321 53.7689 3.76874C53.7689 5.90426 52.1357 7.53747 50.0001 7.53747C26.6331 7.53747 7.53771 26.6329 7.53771 49.9999C7.53771 73.3669 26.6331 92.4623 50.0001 92.4623C73.3671 92.4623 92.4625 73.3669 92.4625 49.9999C92.4625 47.8641 94.0957 46.2311 96.2313 46.2311C98.3668 46.2311 100 47.8644 100 49.9999C100 77.5126 77.5126 100 50.0001 100Z",
    fill: "#91B848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.22dd803a1bd17eb7da4c54b26df4c165.svg";
export { ForwardRef as ReactComponent };